import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';

const Checkout: React.FC = () => {
  const { items, totalPrice, clearCart } = useCart();
  const { formatPrice } = useCurrency();
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    clearCart();
  };

  if (submitted) {
    return (
      <div className="checkout-page">
        <div className="order-success">
          <div className="success-icon">&#10003;</div>
          <h2>Order Placed Successfully!</h2>
          <p>Thank you for your purchase, {formData.full_name}.</p>
          <p>We'll send a confirmation to {formData.email}.</p>
          <Link to="/shop" className="btn btn-primary">Continue Shopping</Link>
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="checkout-page">
        <div className="empty-cart">
          <h2>Your cart is empty</h2>
          <Link to="/shop" className="btn btn-primary">Go Shopping</Link>
        </div>
      </div>
    );
  }

  const shipping = totalPrice >= 100 ? 0 : 9.99;

  return (
    <div className="checkout-page">
      <h1>Checkout</h1>

      <div className="checkout-layout">
        <form className="checkout-form" onSubmit={handleSubmit}>
          <h3>Shipping Information</h3>

          <div className="form-group">
            <label htmlFor="full_name">Full Name</label>
            <input type="text" id="full_name" name="full_name" value={formData.full_name}
              onChange={handleChange} required />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email}
                onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input type="tel" id="phone" name="phone" value={formData.phone}
                onChange={handleChange} required />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="address">Address</label>
            <textarea id="address" name="address" value={formData.address}
              onChange={handleChange} required rows={3} />
          </div>

          <div className="form-group">
            <label htmlFor="city">City</label>
            <input type="text" id="city" name="city" value={formData.city}
              onChange={handleChange} required />
          </div>

          <button type="submit" className="btn btn-primary btn-lg btn-full">
            Place Order - {formatPrice(totalPrice + shipping)}
          </button>
        </form>

        <div className="checkout-summary">
          <h3>Order Summary</h3>
          {items.map((item, index) => {
            const price = item.product.discount_price
              ? parseFloat(item.product.discount_price)
              : parseFloat(item.product.price);
            return (
              <div key={index} className="checkout-item">
                <div>
                  <p className="checkout-item-name">{item.product.name}</p>
                  <p className="checkout-item-meta">
                    Qty: {item.quantity}
                    {item.size && ` | ${item.size}`}
                    {item.color && ` | ${item.color}`}
                  </p>
                </div>
                <span>{formatPrice(price * item.quantity)}</span>
              </div>
            );
          })}
          <div className="summary-divider" />
          <div className="summary-row">
            <span>Subtotal</span>
            <span>{formatPrice(totalPrice)}</span>
          </div>
          <div className="summary-row">
            <span>Shipping</span>
            <span>{shipping === 0 ? 'Free' : formatPrice(shipping)}</span>
          </div>
          <div className="summary-row total">
            <span>Total</span>
            <span>{formatPrice(totalPrice + shipping)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
